import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import isObject from '#shared/util/isObject.js';

import { getRequestPath } from '#backend/util/request.js';

/**
 * Redirect to the order page if no cart data found (eg. session expired)
 */
export default defineThemeMiddleware(({ request, response, redirect }) => {
	// Load SessionStore from request context
	const { sessionStore } = response.locals;
	// If redirect after submit was required, continue
	if (sessionStore?.store.pendingRedirect) {
		return;
	}
	// If any page is loading, cart was not submitted and there is no payment information, redirect to the order page
	if (/company-details|confirm-order|thank-you|invoice/.test(getRequestPath(request)) && !isObject(sessionStore?.store.submittedCart) && !isObject(sessionStore?.store.paymentMethod) && !isObject(sessionStore?.store.selectedPaymentMethod)) {
		redirect(301, request.originalUrl.replace(/company-details|confirm-order|thank-you|invoice/, ''));
	}
}, (context) => context.isServerProcess);
